module.exports = __webpack_public_path__ + "img/d01.6edb935c.jpg";